export default __webpack_public_path__ + "static/media/play.bc6a9004.svg";